import React from "react";
import { BrowserRouter, Switch, Redirect, Route, Link, NavLink } from "react-router-dom";

var ReactDOM = require('react-dom')

import { MojCasinoHorizontal } from './MojCasinoHorizontal.jsx'
import MojCasinoHorizontalProvideri from './MojCasinoHorizontalProvideri.jsx'
import { MaratonHappyHour } from './MaratonHappyHour.jsx'

import { MojCasinoPobjedniciDana } from './MojCasinoPobjedniciDana.jsx'

import { MojCasinoKategorije } from './MojCasinoKategorije.jsx'

import HomePromotionComponent from './HomePromotionComponent.jsx';
import JackpotCounter from './JackpotCounter.jsx';
import Flickity from 'flickity';
import 'flickity/dist/flickity.min.css';
import { PokerWidget } from "../Poker/PokerWidget.jsx";
import { SuperCasinoUtrkeWidget } from "../Casino/SuperCasinoUtrkeWidget.jsx";
import { LiveGamesWidget } from "./LiveGamesWidget.jsx";
import { SuperKlubWidget } from "./SuperKlubWidget.jsx";


export class MojCasino extends React.Component {
    constructor(props) {
        super(props);

        this.fetchData = this.fetchData.bind(this);
        this.setData = this.setData.bind(this);

        this.state = {
            selectedTheme: null,
            selectedPlayerTab: 'Najčešće igrano',
            ponovnoTabs: ['Najčešće igrano', 'Posljednje odigrano'],
            activeComponents: [],
            teme: [],
            frosmoComponetIsBlocked: false,
            componentSelectedCategories: [59, 50, 284, 296, 295, 63, 19, 58, 39, 57, 224, 214, 230],
            selectedCategory: null,
            liveRtpGames: null,
            superBotGames: [],
            liveRtpTabs: ['12 sati', '24 sata', '48 sati'],
            selectedLiveRtpHotTab: '12 sati',
            selectedLiveRtpColdTab: '12 sati',
            selectedThemeIndex: 0,
            selectedCategoryIndex: 0,
            homePromotionComponentIndex: 0,
            casinoPromotions: null,
            tabletView: false,
        }

        this.getJackpot = this.getJackpot.bind(this);
        this.addFlickityToThemes = this.addFlickityToThemes.bind(this);
        this.addFlickityToCategories = this.addFlickityToCategories.bind(this);
        this.addFlickityToPromotionComponent = this.addFlickityToPromotionComponent.bind(this);
        this.refreshFlickity = this.refreshFlickity.bind(this);
        this.handleResize = this.handleResize.bind(this);
        this.handleLoad = this.handleLoad.bind(this);
        this.filterRtpGames = this.filterRtpGames.bind(this);
        this.fetchData();
    }

    /***** MY METHODS *****/
    getPromotions() {
        casino.repos.casinoPromotionsRepo.list(null, true).then(result => {
            this.setState({ casinoPromotions: result }, () => {
                this.addFlickityToPromotionComponent();
            });
        });
    }

    refreshFlickity() {
        if (this.flickity) {
            this.flickity.destroy();
        }

        this.flickity = new Flickity('#super-promocije', this.flickityOptionsPromotions || {});
    }

    handleLoad() {
        if (this.flickity)
            this.flickity.resize();
    }

    handleResize() {
        if (this.width !== window.innerWidth) {
            this.width = window.innerWidth;

            let itemsNumber = this.width >= 700 ? 2 : 1;
            this.flickityOptionsPromotions.groupCells = itemsNumber;

            this.refreshFlickity();
        }
    }

    componentDidMount() {
        var urlInfo = casino.utils.parseQuery(this.props.route.location.search);

        if (urlInfo.lastfrom) {
            var lastFrom = urlInfo.lastfrom;
            let div = urlInfo.lastfrom.split('-').length == 3 ? urlInfo.lastfrom.split('-')[0] + '-' + urlInfo.lastfrom.split('-')[1] : urlInfo.lastfrom;
            let part = urlInfo.lastfrom.split('-').length == 3 ? urlInfo.lastfrom.split('-')[2] : "";

            if (div == "mc-ponovno" && (part == '0' || part == '1')) {
                this.setState({ selectedPlayerTab: this.state.ponovnoTabs[part] });
            }
            if (div == "mc-teme" && Object.keys(this.state.teme).indexOf(part) >= 0) {
                this.setState({ selectedTheme: part });
            }

            // if (div == "mc-provideri") {
            //   this.setState({ selectedBrand: part });
            // }
        }

        if (this.props.categories) {
            let selectedCategory = this.props.categories.filter(x => x.id == this.state.componentSelectedCategories[0])[0];
            if (selectedCategory)
                this.setState({ selectedCategory: selectedCategory });
        }

        this.width = window.innerWidth;
        window.addEventListener('resize', this.handleResize);
        window.addEventListener('load', this.handleLoad);

        this.getPromotions();

        this.addFlickityToThemes();
        this.addFlickityToCategories();
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
        window.removeEventListener('load', this.handleLoad);

        if (this.dataPromises && this.dataPromises.cancel) {
            this.dataPromises.cancel();
        }

        if (this.flickity) {
            try { this.flickity.destroy(); } catch (e) { /* ignore */ }
            this.flickity = null;
        }
        if (this.flickityThemes) {
            try { this.flickityThemes.destroy(); } catch (e) { /* ignore */ }
            this.flickityThemes = null;
        }
        if (this.flickityCategories) {
            try { this.flickityCategories.destroy(); } catch (e) { /* ignore */ }
            this.flickityCategories = null;
        }
        if (this.flickityPromotions) {
            try { this.flickityPromotions.destroy(); } catch (e) { /* ignore */ }
            this.flickityPromotions = null;
        }
    }

    addFlickityToThemes() {
        //add flickity when container becomes visible
        if (document.getElementById('themes-container') == null) {
            setTimeout(() => this.addFlickityToThemes(), 100);
        } else {
            let self = this;
            this.flickityOptions = {
                pageDots: false,
                prevNextButtons: false,
                selectedAttraction: 0.03,
                friction: 1,
                selectedAttraction: 0.3,
                wrapAround: true,
                on: {
                    change: function (index) {
                        self.setState({ selectedThemeIndex: index });
                    }
                }
            }
            this.flickityThemes = new Flickity('#themes-container', this.flickityOptions || {});
        }
    }

    addFlickityToCategories() {
        //add flickity when container becomes visible
        if (document.getElementById('categories-container') == null) {
            setTimeout(() => this.addFlickityToCategories(), 100);
        } else {
            let self = this;
            this.flickityOptions = {
                pageDots: false,
                prevNextButtons: false,
                selectedAttraction: 0.03,
                friction: 1,
                selectedAttraction: 0.3,
                on: {
                    change: function (index) {
                        self.setState({ selectedCategoryIndex: index });
                    }
                }
            }
            this.flickityCategories = new Flickity('#categories-container', this.flickityOptions || {});
        }
    }

    addFlickityToPromotionComponent() {
        //add flickity when container becomes visible and has children
        const container = document.getElementById('super-promocije');
        if (container == null || container.children.length === 0) {
            setTimeout(() => this.addFlickityToPromotionComponent(), 100);
            return;
        }
        if (this.flickityPromotions) {
            try { this.flickityPromotions.destroy(); } catch (e) { /* ignore */ }
            this.flickityPromotions = null;
        }
        {
            this.width = window.innerWidth;
            let itemsNumber = this.width >= 700 ? 2 : 1;
            let self = this;
            this.flickityOptionsPromotions = {
                groupCells: itemsNumber,
                cellAlign: 'center',
                pageDots: false,
                prevNextButtons: false,
                selectedAttraction: 0.03,
                friction: 1,
                selectedAttraction: 0.3,
                autoPlay: 6000,
                wrapAround: true,
                useOffscreenRenderer: true,
                on: {
                    change: function (index) {
                        self.setState({ homePromotionComponentIndex: index });
                    }
                }
            }
            this.flickityPromotions = new Flickity('#super-promocije', this.flickityOptionsPromotions || {});
        }
    }

    fetchData() {
        this.props.showLoadingFn(true);
        var promises = Promise.all([casino.repos.casinoKomponenteRepo.get(), casino.repos.casinoThemesRepo.list(), casino.repos.liveRtpGamesRepo.get(), casino.repos.superBotRepo.get()]);
        this.dataPromises = casino.utils.makeCancelablePromise(promises);
        this.dataPromises.promise.then(this.setData, function (reason) { });
    }

    setData(data) {
        this.setState({ activeComponents: data[0], teme: data[1], selectedTheme: data[1][0], liveRtpGames: data[2], superBotGames: data[3].length ? data[3] : [] });
        this.props.showLoadingFn(false);
    }

    filterRtpGames(period, hot) {
        let result = [];
        this.state.liveRtpGames.filter(it => (hot ? it.rtp > 100 : it.rtp < 100) && it.satInterval == period).forEach(rtpGame => {
            let game = { ...this.props.igre.find(it => it.s == rtpGame.sifraMobile) };

            if (game) {
                game.rtp = rtpGame.rtp;
                result.push(game);
            }
        });
        return result;
    }

    getJackpot(value) {
        let suma = 0;
        this.props.jackpots.map(x => {
            if (x[0] == value || value == 99)
                suma += x[1];
        })

        if (suma > 0)
            return casino.utils.numberToString(suma);

        return "-";
    }

    selectTheme(x) {
        this.setState({ selectedTheme: x });
        casino.utils.createClickGoogleTagManagerEvent(x.naziv, 'teme', 'casino', this.props.user);
    }

    selectSelectedCategory(x) {
        this.setState({ selectedCategory: x });
        casino.utils.createClickGoogleTagManagerEvent(x.naziv, 'odabrane kategorije', 'casino', this.props.user);
    }

    renderZaigrajPonovno(index, c) {
        return (this.props.user && this.props.userChecked && this.props.user.zadnjeIgrano.length > 0 &&
            <div key={index} id="mc-ponovno" className="zaigraj-ponovno-line  moj-casino-line">
                <h2 className="homepage-margin2">Tvoje zadnje odigrano</h2>
                <MojCasinoHorizontal
                    showSmall={true}
                    brojRedova={1}
                    from="mc-ponovno-1"
                    games={this.props.user.zadnjeIgrano}
                    showAll={false}
                    {...this.props}
                    showGameName={true}
                    igraPozicija={c.igraPozicija}
                    brands={this.props.brands}
                    // GamePosition podaci, HizmanB
                    PageName="Home"
                    PositionType="component"
                    ComponentName={"tvoje-zadnje-odigrano"}
                    ComponentPosition={index}
                    IsIcon={true}>
                </MojCasinoHorizontal>
            </div>)
    }

    renderNajcesceIgrano(index, c) {
        return (this.props.user && this.props.userChecked && this.props.user.najigranije.length > 0 &&
            <div key={index} id="mc-ponovno" className="zaigraj-ponovno-line  moj-casino-line">
                <h2 className="homepage-margin2">Tvoje najčešće igrano</h2>
                <MojCasinoHorizontal
                    showSmall={true}
                    brojRedova={1}
                    from="mc-ponovno-1"
                    games={this.props.user.najigranije}
                    showAll={false}
                    {...this.props}
                    showGameName={true}
                    igraPozicija={c.igraPozicija}
                    brands={this.props.brands}
                    // GamePosition podaci, HizmanB
                    PageName="Home"
                    PositionType="component"
                    ComponentName={"tvoje-najcesce-igrano"}
                    ComponentPosition={index}
                    IsIcon={true}>
                </MojCasinoHorizontal>
            </div>)
    }

    renderNajigranijeUTvomKraju(index, c) {
        return (this.props.user && this.props.userChecked && this.props.user.najigranijeUMomKraju.length > 0 &&
            <div key={index} id="mc-u-tvom-kraju" className="moj-casino-line">
                <h2 className="homepage-margin2">Najigranije u tvom kraju</h2>
                <MojCasinoHorizontal
                    brojRedova={c.brojRedova}
                    from="mc-ponovno-1"
                    games={this.props.user.najigranijeUMomKraju}
                    showAll={false}
                    {...this.props}
                    showGameName={true}
                    igraPozicija={c.igraPozicija}
                    // GamePosition podaci, HizmanB
                    PageName="Home"
                    PositionType="component"
                    ComponentName={"najigranije-u-tvom-kraju"}
                    ComponentPosition={index}
                    IsIcon={true}>
                </MojCasinoHorizontal>
            </div>)
    }

    renderPromocijeITurniri(index) {
        return <div key={index} className={"bonusi-line  moj-casino-line"} id="mc-bonusi">
            <h2 className="homepage-margin2">Promocije i turniri</h2>
            <div className="happy-hour">
                <div className="bannerContainer">
                    <div className="banner1"></div>
                </div>
                <MaratonHappyHour {...this.props} hideHeader={true} extraClass="maraton2 from-moj-casino" />
                <div className="text-center">
                    <NavLink to={'/promotions/happy-hour'} className="btn-red btn-white margin-top-small">
                        Kako se natjecati?
                    </NavLink>
                </div>
            </div>
        </div>
    }

    renderPopularneTemeOld(index) {
        let teme = this.state.teme;
        return <div key={index} className={"teme-line  moj-casino-line " + this.state.selectedTheme.sifra} id="mc-teme">
            <h2 className="homepage-margin2">Popularne teme <NavLink to="/teme"> <span className="btn-red" >Prikaži sve</span></NavLink>
            </h2>
            <div style={{ position: 'relative', marginTop: '-8px' }}>
                <div id="game-tabs" className="relative" style={{ marginRight: '0px', backgroundColor: 'transparent' }}>
                    <div className="kategorije-transparent kategorije-transparent-first"></div><div className="maximum"><ul className="tick" id="categories-swiper">
                        {
                            teme.map(x => <li key={x.sifra} className={(this.state.selectedTheme.sifra == x.sifra ? "selected" : "")}>  <button onClick={() => this.selectTheme(x)}><span>{x.naziv}</span></button></li>)
                        }
                    </ul></div></div></div>

            <div className={"theme-text " + this.state.selectedTheme.sifra} >
                <h2 className="padding-0">{this.state.selectedTheme.naziv}</h2>
                <div className="theme-opis">{this.state.selectedTheme.opis}</div>
                <NavLink to={{ pathname: '/teme/' + this.state.selectedTheme.sifra, state: { fromHomepage: true } }} className="btn-red btn-white">Prikaži sve</NavLink>
            </div>
            <MojCasinoHorizontal
                from={"mc-teme-" + this.state.selectedTheme.sifra}
                showGameName={true}
                name=""
                randomSort={true}
                randomSortOffset={21}
                key={this.state.selectedTheme.sifra}
                showAll={false}
                showSmall={true}
                {...this.props}
                tema={this.state.selectedTheme}
                brands={this.props.brands}
                // GamePosition podaci, HizmanB
                PageName="Home"
                PositionType="component"
                ComponentName={"popularne-teme"}
                ComponentPosition={index}
                IsIcon={true}
                SliderName={this.state.selectedTheme.sifra.toLowerCase().replace(/\s+/g, '-')}
                SliderPosition={i}>
            </MojCasinoHorizontal>
        </div>
    }

    renderPopularneTeme(index) {
        let teme = this.state.teme;
        return <React.Fragment key={"tema" + index}>
            <h2 className="homepage-margin2">
                <NavLink className="component-title theme-title" to="/teme">Popularne teme</NavLink>
                {/*<NavLink to="/teme"> <span className="btn-red" >Prikaži sve</span></NavLink>*/}
            </h2>
            {/* <div style={{ position: 'relative', marginTop: '-8px' }}>
                <div id="game-tabs" className="relative" style={{ marginRight: '0px', backgroundColor: 'transparent' }}>
                    <div className="kategorije-transparent kategorije-transparent-first"></div><div className="maximum"><ul className="tick" id="categories-swiper">
                        {
                            teme.map((x, i) => <li key={x.sifra} className={(this.state.selectedThemeIndex == i ? "selected" : "")}>  <button onClick={() => { this.flickityThemes.select(i); this.setState({ selectedThemeIndex: i }) }}><span>{x.naziv}</span></button></li>)
                        }
                    </ul></div></div></div> */}
            <div id="themes-container">
                {teme.map((t, i) => {
                    return <div key={t.sifra} className={"teme-line  moj-casino-line " + t.sifra} id="mc-teme">
                        <div className={`floater ${t.sifra}`} />
                        <div className={`bottom-gradient ${t.sifra}`} />

                        <div className="theme-content">
                            <h2 className="theme-name">{t.naziv}</h2>
                            <div onTouchMove={(e) => e.stopPropagation()}>
                                {i === this.state.selectedThemeIndex &&
                                    <MojCasinoHorizontal
                                        from={"mc-teme-" + t.sifra}
                                        showGameName={true}
                                        name=""
                                        randomSort={true}
                                        randomSortOffset={21}
                                        key={t.sifra}
                                        showAll={false}
                                        showSmall={false}
                                        brojRedova={2}
                                        {...this.props}
                                        tema={t}
                                        brands={this.props.brands}
                                        isAppIcon={true}
                                        // GamePosition podaci, HizmanB
                                        PageName="Home"
                                        PositionType="component"
                                        ComponentName={"popularne-teme"}
                                        ComponentPosition={index}
                                        IsIcon={true}
                                        SliderName={t.naziv.toLowerCase().replace(/\s+/g, '-')}
                                        SliderPosition={i + 1}
                                    />
                                }
                            </div>

                            <a href={casino.utils.getBaseUrl() + 'teme?tema=' + t.sifra} className="theme-btn">Prikaži sve</a>
                        </div>
                    </div>
                })}
            </div>
        </React.Fragment>
    }

    renderJackpotIgre(index) {
        return <div key={index} className="jackpot-line">
            <div className="jackpot-img"></div>
            <MojCasinoHorizontal
                from="mc-jackpot"
                name="Jackpot igre"
                desc="Istraži tajanstvene SuperCasino Jackpote"
                catId="10"
                catName="Jackpot"
                showAll={false}
                showSmall={true}
                jackpotSort={true}
                {...this.props}
                showJackpotValue={true}
                showGameName={false}
                randomSortOffset={6}
                brands={this.props.brands}
                // GamePosition podaci, HizmanB
                PageName="Home"
                PositionType="component"
                ComponentName={"jackpot-igre"}
                ComponentPosition={index}
                IsIcon={true}>
            </MojCasinoHorizontal>
            <div style={{ textAlign: "center" }} className="jackpot-fotter">
                <h3>Ukupan iznos JACKPOTA</h3>
                <div className="jackpot-dobitci-container home-page-jackpot text-center">
                    <div className="jackpot-iznos-img"></div>
                    <div className="iznos text-ellipsis">
                        <JackpotCounter {...this.props} />
                    {/*    <span>{casino.utils.numberWithCurrencyFromated(this.props.jackpotsUkupno.iznos, this.props.jackpotsUkupno.valuta)}</span>*/}
                    </div>
                </div>
            </div>
        </div>
    }

    renderPobjedniciDana(index) {
        return <MojCasinoPobjedniciDana
            key={index}
            from="mc-pobjednici"
            {...this.props}
            // GamePosition podaci, HizmanB
            PageName="Home"
            PositionType="component"
            ComponentName={"pobjednici-dana"}
            ComponentPosition={index}
            IsIcon={true}>
        </MojCasinoPobjedniciDana>
    }

    renderProvideri(index) {
        return <MojCasinoHorizontalProvideri
            key={index}
            from="mc-provideri"
            showAll={true}
            text="Omiljeni provideri"
            {...this.props}
            brands={this.props.brands}>
        </MojCasinoHorizontalProvideri>
    }

    renderJelTiPromaklo(index) {
        return <MojCasinoKategorije key={index} {...this.props}></MojCasinoKategorije>
    }

    renderSuperBot(index) {
        return <div key={index} id="frosmo-super-bot" className="frosmo-super-bot">
            <div className="frosmo-recomendation fr-mobile">
                <div className="superbot-line moj-casino-line">
                    <div className="fr-main-image">
                        <div className={"png-image "}></div>
                    </div>
                    <div className={"theme-text "}>
                        <h2 className="padding-0">Odabrao sam za tebe</h2>
                        <div className={"tekst"}>Mislim da će ti se ove igre svidjeti. Zaigraj i zabavi se!</div>
                    </div>
                    <div className="moj-casino-line">
                        <MojCasinoHorizontal
                            name=""
                            isAppIcon={true}
                            from="mc-superbot"
                            superBotGames={this.state.superBotGames}
                            showAll={false}
                            {...this.props}
                            showGameName={true}
                            showSmall={false}
                            brojRedova={2}
                            // GamePosition podaci, HizmanB
                            PageName="Home"
                            PositionType="component"
                            ComponentName={"frosmo-super-bot"}
                            ComponentPosition={index}
                            IsIcon={true}>
                        </MojCasinoHorizontal>
                    </div>
                </div>
            </div>
        </div>
    }

    renderOdabraneKategorijeOld(index) {

        let categoryName = this.state.selectedCategory && this.state.selectedCategory.name.split(' ').join('-').toLowerCase();
        let selectedCategories = [];
        for (var i = 0; i < this.state.componentSelectedCategories.length; i++) {
            var category = this.props.categories.find(x => x.id == this.state.componentSelectedCategories[i]);
            if (category)
                selectedCategories.push(category);
        }

        return <div key={index} className={"selected-category-line"} id="mc-selected-category">
            <h2 className="homepage-margin2" style={{ paddingRight: '0' }}>Odabrane kategorije</h2>
            <div style={{ position: 'relative', marginTop: '-8px' }}>
                <div id="game-tabs" className="relative" style={{ marginRight: '0px' }}>
                    <div className="kategorije-transparent kategorije-transparent-first"></div><div className="maximum"><ul className="tick" id="categories-swiper">
                        {
                            selectedCategories.map(x => <li key={x.name} className={(this.state.selectedCategory && this.state.selectedCategory.id == x.id ? "selected" : "")}>  <button onClick={() => this.selectSelectedCategory(x)}><span>{x.name}</span></button></li>)
                        }
                    </ul></div></div></div>
            <div className={categoryName}>
                <div className="category-floater"></div>
                <MojCasinoHorizontal
                    isAppIcon={true}
                    showSmall={false}
                    brojRedova={2}
                    from={"mc-teme-" + categoryName}
                    name=""
                    showGameName={true}
                    randomSort={true}
                    randomSortOffset={21}
                    key={categoryName}
                    showAll={false}
                    {...this.props}
                    catId={this.state.selectedCategory && this.state.selectedCategory.id.toString()}
                    // GamePosition podaci, HizmanB
                    PageName="Home"
                    PositionType="component"
                    ComponentName={"odabrane-kategorije"}
                    ComponentPosition={index}
                    IsIcon={true}
                    SliderName={categoryName.toLowerCase().replace(/\s+/g, '-')}
                    SliderPosition={x}>
                </MojCasinoHorizontal>
            </div>
        </div>
    }

    renderOdabraneKategorije(index) {
        let selectedCategories = [];

        for (var i = 0; i < this.state.componentSelectedCategories.length; i++) {
            var category = this.props.categories.find(x => x.id == this.state.componentSelectedCategories[i]);
            if (category)
                selectedCategories.push(category);
        }
        
        return <React.Fragment key={"kategorija" + index}>
            <h2 className="homepage-margin2" style={{ paddingRight: '0', marginBottom: '1.5rem' }}>Odabrane kategorije</h2>
            <div style={{ position: 'relative', marginTop: '-8px' }}>
                <div id="game-tabs" className="relative transparent" style={{ marginRight: '0px' }}>
                    <div className="kategorije-transparent kategorije-transparent-first"></div><div className="maximum"><ul className="tick" id="categories-swiper">
                        {
                            selectedCategories.map((x, i) => <li key={x.name} className={(this.state.selectedCategoryIndex == i ? "selected" : "")}>  <button onClick={() => { this.flickityCategories.select(i); this.setState({ selectedCategoryIndex: i }) }}><span>{x.name}</span></button></li>)
                        }
                    </ul></div></div></div>
            <div id="categories-container" className="no-transition" style={{ marginBottom: "4rem" }} >
                {selectedCategories.map((c, i) => {
                    return <div key={"cat" + i} className={"selected-category-line"} id="mc-selected-category" style={{ width: "100%", marginBottom: "-115px" }}>
                        <div className={c.name.split(' ').join('-').toLowerCase()}>
                            <div className="category-floater" style={{ top: "0%" }}/>
                            
                            <div className="category-games-box" onTouchMove={(e) => e.stopPropagation()}>
                                {i === this.state.selectedCategoryIndex && <MojCasinoHorizontal
                                    isAppIcon={true}
                                    showSmall={false}
                                    brojRedova={2}
                                    from={"mc-teme-" + c.name.split(' ').join('-').toLowerCase()}
                                    name=""
                                    showGameName={true}
                                    randomSort={true}
                                    randomSortOffset={21}
                                    key={c.name.split(' ').join('-').toLowerCase()}
                                    showAll={false}
                                    {...this.props}
                                    catId={c.id.toString()}
                                    // GamePosition podaci, HizmanB
                                    PageName="Home"
                                    PositionType="component"
                                    ComponentName={"odabrane-kategorije"}
                                    ComponentPosition={index}
                                    IsIcon={true}
                                    SliderName={c.name.toLowerCase().replace(/\s+/g, '-')}
                                    SliderPosition={i + 1}>
                                </MojCasinoHorizontal>
                                }
                            </div>
                        </div>
                    </div>
                })}
            </div>
        </React.Fragment>
    }

    renderLiveRtpHot(index, c) {
        return (this.state.liveRtpGames &&
            <div key={index} id="mc-ponovno" className="zaigraj-ponovno-line  moj-casino-line">
                <h2 className="homepage-margin2">
                    {c.naslov}
                </h2>
                <div className="homepage-margin2">
                    <div className="segment v2">
                        {this.state.liveRtpTabs.map((tab) =>
                            <button key={tab} onClick={() => this.setState({ selectedLiveRtpHotTab: tab })} className={'segment--btn' + (this.state.selectedLiveRtpHotTab === tab ? ' selected' : '')}><span>{tab}</span></button>
                        )}
                    </div>
                </div>
                {this.state.selectedLiveRtpHotTab === '12 sati' &&
                    <MojCasinoHorizontal
                        from="mc-livertphot-1"
                        games={this.filterRtpGames(12, true)}
                        showAll={false}
                        {...this.props}
                        showGameName={true}
                        brojRedova={1}
                        showRtp={true}
                        // GamePosition podaci, HizmanB
                        PageName="Home"
                        PositionType="component"
                        ComponentName={c.naslov}
                        ComponentPosition={index}
                        IsIcon={true}>
                    </MojCasinoHorizontal>}
                {this.state.selectedLiveRtpHotTab === '24 sata' &&
                    <MojCasinoHorizontal
                        from="mc-livertphot-2"
                        games={this.filterRtpGames(24, true)}
                        showAll={false}
                        {...this.props}
                        showGameName={true}
                        brojRedova={1}
                        showRtp={true}
                        // GamePosition podaci, HizmanB
                        PageName="Home"
                        PositionType="component"
                        ComponentName={c.naslov}
                        ComponentPosition={index}
                        IsIcon={true}>
                    </MojCasinoHorizontal>}
                {this.state.selectedLiveRtpHotTab === '48 sati' &&
                    <MojCasinoHorizontal
                        from="mc-livertphot-3"
                        games={this.filterRtpGames(48, true)}
                        showAll={false}
                        {...this.props}
                        showGameName={true}
                        brojRedova={1}
                        showRtp={true}
                        // GamePosition podaci, HizmanB
                        PageName="Home"
                        PositionType="component"
                        ComponentName={c.naslov}
                        ComponentPosition={index}
                        IsIcon={true}>
                    </MojCasinoHorizontal>}
            </div>)
    }

    renderLiveRtpCold(index, c) {
        return (this.state.liveRtpGames &&
            <div key={index} id="mc-ponovno" className="zaigraj-ponovno-line  moj-casino-line">
                <h2 className="homepage-margin2">
                    {c.naslov}
                </h2>
                <div className="homepage-margin2">
                    <div className="segment v2">
                        {this.state.liveRtpTabs.map((tab) =>
                            <button key={tab} onClick={() => this.setState({ selectedLiveRtpColdTab: tab })} className={'segment--btn' + (this.state.selectedLiveRtpColdTab === tab ? ' selected' : '')}><span>{tab}</span></button>
                        )}
                    </div>
                </div>
                {this.state.selectedLiveRtpColdTab === '12 sati' &&
                    <MojCasinoHorizontal
                        from="mc-livertpcold-1"
                        games={this.filterRtpGames(12, false)}
                        showAll={false}
                        {...this.props}
                        showGameName={true}
                        brojRedova={1}
                        showRtp={true}
                        // GamePosition podaci, HizmanB
                        PageName="Home"
                        PositionType="component"
                        ComponentName={c.naslov}
                        ComponentPosition={index}
                        IsIcon={true}>
                    </MojCasinoHorizontal>}
                {this.state.selectedLiveRtpColdTab === '24 sata' &&
                    <MojCasinoHorizontal
                        from="mc-livertpcold-2"
                        games={this.filterRtpGames(24, false)}
                        showAll={false}
                        {...this.props}
                        showGameName={true}
                        brojRedova={1}
                        showRtp={true}
                        // GamePosition podaci, HizmanB
                        PageName="Home"
                        PositionType="component"
                        ComponentName={c.naslov}
                        ComponentPosition={index}
                        IsIcon={true}>
                    </MojCasinoHorizontal>}
                {this.state.selectedLiveRtpColdTab === '48 sati' &&
                    <MojCasinoHorizontal
                        from="mc-livertpcold-3"
                        games={this.filterRtpGames(48, false)}
                        showAll={false}
                        {...this.props}
                        showGameName={true}
                        brojRedova={1}
                        showRtp={true}
                        // GamePosition podaci, HizmanB
                        PageName="Home"
                        PositionType="component"
                        ComponentName={c.naslov}
                        ComponentPosition={index}
                        IsIcon={true}>
                    </MojCasinoHorizontal>}
            </div>)
    }

    renderKomponenta(index, c) {
        const isVerticalImage = c.sifra === 'super-ekskluzivno' || c.sifra === 'super-igre' ;

        return (
            <MojCasinoHorizontal
                key={index}
                brojRedova={c.brojRedova}
                from={c.from}
                name={c.naslov}
                catId={String(c.kategorijaIgraID)}
                showAll={c.prikaziSveButton}
                {...this.props}
                showGameName={true}
                randomSort={c.randomSort}
                randomSortOffset={c.randomSortOffset}
                showSmall={c.vrstaIkone == 2 || c.vrstaIkone == 3}
                vrstaIkone={c.vrstaIkone}
                igraPozicija={c.igraPozicija}
                sifra={c.sifra}
                brandID={c.brandID}
                isVerticalImage={isVerticalImage}
                // GamePosition podaci, HizmanB
                PageName="Home"
                PositionType="component"
                ComponentName={c.sifra}
                ComponentPosition={index}
                IsIcon={c.vrstaIkone == 2 || c.vrstaIkone == 3}
            />
        );


    }

    renderPokerTurniriComponent(index, c) {
        return (
            <PokerWidget
                key={"poker-turniri" + index}
                title={c.naslov}
            />
        )
    }

    renderCasinoUtrkeComponent(index, c) {
        if (this.props.user?.igracID !== null && this.props.user?.igracID !== undefined) {
            return (
                <SuperCasinoUtrkeWidget
                    key={"supercasino-utrke" + index}
                />
            )
        }
    }
    renderSuperKlubComponent(index, c) {
        return (
            <SuperKlubWidget
                key={"super-klub-widget-" + index}
                isLoggedIn={this.props.user?.igracID != null && this.props.user?.igracID !== undefined}
            />
        );
    }

    renderLiveGamesComponent(index, c) {
        return (
            <LiveGamesWidget
                key={"livegames" + index}
                categories={this.props.categories}
                {...this.props}
            />
        )
    }

    renderHomePromotionWidget() {
        return (
            <div key="superPromo" className="super-promocije">
                <h2 className="homepage-margin2">
                    <NavLink to="/promotions" className="component-title theme-title"> Super Promocije </NavLink>
                </h2>

                <div key="super-promo" id="super-promocije">
                    {this.state.casinoPromotions?.map((promotion, index) => (
                        <div key={"promotion" + index} className="super-promocije-line" id="mc-super-promocije">
                            <HomePromotionComponent
                                key={"super-promocije " + index}
                                index={index}
                                selectedIndex={this.state.homePromotionComponentIndex}
                                promotion={promotion.code}
                                startDate={promotion.startDate}
                                endDate={promotion.endDate}
                                backgroundColor={promotion.backgroundColor}
                                amount={promotion.totalPrize}
                                buttonAction={promotion.buttonActionMobile}
                                customLink={promotion.customLinkMobile}
                            />
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    render() {
        return (
            <div>
                {this.state.activeComponents.map((c, index) => {
                    const displayIndex = index + 1;
                    if (c.sifra == 'zaigraj-ponovno') {
                        return this.renderZaigrajPonovno(displayIndex, c);
                    }
                    else if (c.sifra == 'super-promocije') {
                        return this.renderHomePromotionWidget(displayIndex, c);
                    }
                    else if (c.sifra == 'promocije-turniri') {
                        return this.renderPromocijeITurniri(displayIndex);
                    }
                    else if (c.sifra == 'popularne-teme' && this.state.teme.length > 0) {
                        return this.renderPopularneTeme(displayIndex);
                    }
                    else if (c.sifra == 'jackpot-igre') {
                        return this.renderJackpotIgre(displayIndex);
                    }
                    else if (c.sifra == 'najcesce-igrano') {
                        return this.renderNajcesceIgrano(displayIndex, c);
                    }
                    else if (c.sifra == 'pobjednici-dana') {
                        return this.renderPobjedniciDana(displayIndex);
                    }
                    else if (c.sifra == 'provideri') {
                        return this.renderProvideri(displayIndex);
                    }
                    else if (c.sifra == 'je-li-ti-promaklo') {
                        return this.renderJelTiPromaklo(displayIndex);
                    }
                    else if (c.sifra == 'frosmo-super-bot') {
                         if (this.state.superBotGames && this.state.superBotGames?.length !== 0 && this.props.user) {
                             return this.renderSuperBot(displayIndex);
                         }
                         else return
                    }
                    else if (c.sifra == 'odabrane-kategorije') {
                        return this.renderOdabraneKategorije(displayIndex);
                    }
                    else if (c.sifra == 'live-rtp-hot') {
                        return this.renderLiveRtpHot(displayIndex, c);
                    }
                    else if (c.sifra == 'live-rtp-cold') {
                        return this.renderLiveRtpCold(displayIndex, c);
                    }
                    if (c.sifra == 'najigranije-u-tvom-kraju') {
                        return this.renderNajigranijeUTvomKraju(displayIndex, c);
                    }
                    if (c.sifra == 'poker-turniri') {
                        return this.renderPokerTurniriComponent(index, c);
                    }
                    if (c.sifra == 'supercasino-utrke') {
                        return this.renderCasinoUtrkeComponent(index, c);
                    }
                    if (c.sifra == 'super-klub') {
                        return this.renderSuperKlubComponent(index, c);
                    }
                    if (c.sifra == 'livegames') {
                        return this.renderLiveGamesComponent(index, c);
                    }
                    else {
                        return this.renderKomponenta(displayIndex, c);
                    }
                })}
            </div>
        )
    }
};

